// extracted by mini-css-extract-plugin
module.exports = {"loader":"ApiTokenList_loader__Kbpw7","add":"ApiTokenList_add__1NrVB"};